import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import Aux from "../../../../../../components/common/Aux";
import NavIcon from "./../NavIcon";
import NavBadge from "./../NavBadge";
import * as actionTypes from "../../../../../../store/actions";

const NavItem = React.forwardRef(({ item, windowWidth, layout, collapseMenu, onItemClick, onItemLeave }, ref) => {
  let itemTitle = item.icon ? <span className="pcoded-mtext">{item.title}</span> : item.title;
  let itemTarget = item.target ? '_blank' : '';

  let subContent = item.external ? (
    <OverlayTrigger
      placement="right"
      overlay={<Tooltip style={{ pointerEvents: 'none' }}>{item.title}</Tooltip>}
    >
      <div>
        <NavIcon items={item} />
        {itemTitle}
        <NavBadge layout={layout} items={item} />
      </div>
    </OverlayTrigger>
  ) : collapseMenu ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip style={{ pointerEvents: 'none' }}>{item.title}</Tooltip>}
    >
      <NavLink to={item.url} className="nav-link" exact target={itemTarget}>
        <NavIcon items={item} />
        {itemTitle}
        <NavBadge layout={layout} items={item} />
      </NavLink>
    </OverlayTrigger>
  ) : (
    <NavLink to={item.url} className="nav-link" exact target={itemTarget}>
      <NavIcon items={item} />
      {itemTitle}
      <NavBadge layout={layout} items={item} />
    </NavLink>
  );

  let mainContent = layout === 'horizontal' ? (
    <li onClick={onItemLeave}>{subContent}</li>
  ) : windowWidth < 992 ? (
    <li className={item.classes} onClick={onItemClick}>{subContent}</li>
  ) : (
    <li className={item.classes}>{subContent}</li>
  );

  return (
    <Aux ref={ref}>
      {mainContent}
    </Aux>
  );
});

const mapStateToProps = state => ({
  layout: state.main.layout,
  collapseMenu: state.main.collapseMenu,
});

const mapDispatchToProps = dispatch => ({
  onItemClick: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
  onItemLeave: () => dispatch({ type: actionTypes.NAV_CONTENT_LEAVE }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavItem));
